module.exports = __webpack_public_path__ + "static/media/land_inactive.df27eaeb.svg";